
import { defineComponent,ref } from 'vue'

export default defineComponent({
	setup() {
    const form = ref(null);
    const information = ref({
      name: '',
			phoneNumber: ''
    });
    //自定义表单验证
    const checkName = (rule:any, value:any, callback:any) => {
       if (!value) {
        return callback(new Error("姓名不能为空"));
      }
      let r =/^[\u4E00-\u9FFF]{2,6}$/;
      if (!r.test(value)) {
        return callback(new Error("姓名应该为2到6个汉字"));
      }
      callback();
    };
    const checkPhoneNumber = (rule:any, value:any, callback:any) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      }
      let r =/^\d{11}$/;
      if (!r.test(value)) {
        return callback(new Error("手机号应该为11位数字"));
      }
      callback();
    };
    const rules = {
        name: [{validator: checkName, trigger: 'change'}],
        phoneNumber : [{validator: checkPhoneNumber, trigger: 'change'}]
    };
    return{
      form,
      information,
      rules
    };
  },
});
